import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';

const container = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  text-align: center;
`;

const emailHelperText = css`
  color: ${theme.colors.gray[500]};
  white-space: nowrap;
`;

const signOutLink = css`
  cursor: pointer;
`;

const box = css`
  width: 40%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing(1)};
`;

export const classes = { container, emailHelperText, signOutLink, box };
